import http from "@/api";
import { RequestRes } from "@/api/type";

// 创建衣服
export const garmentTypeCreate = (params:any)=>{
    return http.post('/api/garment/create',params).then(res=>{
        return res
    }) as Promise<RequestRes>
}

